import { Default } from '../default';
import { AnyProps } from '../types';

const assignProperties = (link, props) => ({ ...link, ...props });

const assignQuickLinks = (link): JSX.Element => assignProperties(link, {
  type: 'footer-quick',
  'right-icon': 'chevron-right',
  size: 'huge',
  'icon-position': 'after',
});
const assignHelpfulLinks = (link): JSX.Element => assignProperties(link, { type: 'footer-helpful' });
const assignSocialLinks = (link): JSX.Element => assignProperties(link, {
  href: link.link,
  type: 'footer-social',
});
const assignServiceLinks = (link): JSX.Element => assignProperties(link, { type: 'footer-service' });
const assignText = (text): JSX.Element => assignProperties(text, { type: 'footer' });

export const RocheFooter = ({ blok, ...rest }: AnyProps): JSX.Element => {
  const slottedHelpfulLinks = blok.slotted_helpful_links.map(assignHelpfulLinks);
  const slottedQuickLinks = blok.slotted_quick_links.map(assignQuickLinks);
  const slottedSocialLinks = blok.slotted_social_links.map(assignSocialLinks);
  const slottedServiceLinks = blok.slotted_service_links.map(assignServiceLinks);
  const slottedText = blok.slotted_text.map(assignText);
  const slottedStockPrice = blok.canShowStockPrice ? blok.slotted_stock_price : [];

  return Default({
    blok: {
      ...blok,
      slotted_helpful_links: slottedHelpfulLinks,
      slotted_quick_links: slottedQuickLinks,
      slotted_social_links: slottedSocialLinks,
      slotted_service_links: slottedServiceLinks,
      slotted_text: slottedText,
      slotted_stock_price: slottedStockPrice,
    },
    ...rest,
  });
};
